import { RECHARGE_TYPE } from "../../features/orp/enums/recharge-type.enum";
import { AIRTIME, BROADBAND_RECHARGE, BUNDLE_PURCHASE, HBB_BUNDLE } from "../helper/constants";

export const eventEmitter = (
  eventCategory,
  eventName,
  eventAction,
  eventLabel,
  eventValue,
  customParams = {}
) => {
  window.gtag('event', eventName, {
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel,
    event_value: eventValue,
    ...customParams
  });
};

export const getEventName = (rechargeType, action, paymentMethod = null) => {
  const transationType = rechargeType == BUNDLE_PURCHASE ? 'bndl' : (rechargeType == BROADBAND_RECHARGE ? HBB_BUNDLE : (rechargeType == RECHARGE_TYPE.PREPAID_RECHARGE || rechargeType == RECHARGE_TYPE.POSTPAID_BILL_PAY ? AIRTIME : rechargeType));
  let eventName
  if (rechargeType) {
    eventName = `buy_${transationType}_${action}`;
  } else {
    eventName = action
  }
  if (paymentMethod) {
    eventName += `_${paymentMethod}`;
  }
  return eventName;
};


